<template>
    <div v-bind:class="className">
        <label class="control-label"> {{item.label}} </label>
        <input type="radio" class="form-control margin-bottom" v-bind:value="item.value" v-on:input="update" v-bind:placeholder="item.placeholder" v-bind:name="item.name" v-bind:maxlength="item.maxlength">
        <div v-for="error in item.errors" v-bind:class="{'margin-left': item.type=='checkbox'}" class="to-up" id="errors">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default{
    name: 'emt-radio',
    props: {
        item: Object,
        className: String
    },
    methods: {
        update: function (event) {
            var self = this
            self.item.value = event.target.value
        }
    }
}
</script>



// WEBPACK FOOTER //
// emt-radio.vue?8c1c2a9e